const Slider = new function() {
    let el;
    let slider;
    let sliderNav;

    this.init = () => {
        el = document.querySelector('.keen-slider');
        if (!el) return;

        slider = new KeenSlider(el, {
            breakpoints: {
                "(min-width: 601px)": {
                    slides: {
                        perView: 2,
                    },
                },
                "(min-width: 1024px)": {
                    slides: {
                        perView: 3,
                    },
                },
                },
                slides: {
                    perView: 1.1,
                },
        });

        sliderNav = {
            prev: el.closest('.ss-section--9').querySelector('.ss-slider-nav--prev'),
            next: el.closest('.ss-section--9').querySelector('.ss-slider-nav--next'),
        };

        sliderNav.prev.addEventListener('click', slider.prev)
        sliderNav.next.addEventListener('click', slider.next)
    }
}

export default Slider;